{
  "settings": "הגדרות",
  "yourDigitalAssistant": "העוזר הדיגיטלי שלך",
  "getStarted": "התחל לעבוד",
  "login": "כניסה",
  "loggingIn": "התחבר ...",
  "darkMode": "מצב חושך",
  "clearHistory": "ניקוי היסטוריה",
  "historyCleared": "ההיסטוריה נוקתה",
  "changeLanguage": "שפה",
  "termsAndConditions": "תנאים והגבלות",
  "messagePlaceholder": "הזן את ההודעה שלך כאן ...",
  "messagePlaceholderDisabled": "כתיבה מושבתת ...",
  "feedbackTitle": "דרג את החוויה שלך",
  "feedbackPlaceholder": "ספר לנו על זה (לא חובה)",
  "feedbackSend": "שלח",
  "feedbackClose": "סגור",
  "sessionExpired": "הפגישה שלך פגה בגלל חוסר פעילות.",
  "startNewSession": "התחל מושב חדש",
  "apiError": "אופס! משהו השתבש. אנחנו עובדים כדי לתקן את זה ברגע שאנחנו יכולים.",
  "apiErrorOffline": "אינך מחובר לאינטרנט.",
  "tryAgain": "נסה שוב",
  "startOver": "הפעל מחדש",
  "chatEnded": "הצ'אט הסתיים.",
  "chatEndedThankYou": "תודה ששוחחת איתנו!",
  "closeChat": "סגור",
  "startNewChat": "שוחח שוב בצ'אט",
  "humanTakeoverStarted": "אתה מועבר עכשיו לשירות לקוחות ...",
  "humanTakeoverQueued": "מחכה להיות מקושר לסוכן",
  "humanTakeoverAnAgent": "סוכן",
  "humanTakeoverAgentEntered": "נכנס/ה לשיחה",
  "humanTakeoverAgentLogout": "עזב/ה את השיחה",
  "humanTakeoverTransfer": "אתה מועבר לסוכן חדש",
  "humanTakeoverEnded": "אתה משוחח עכשיו עם העוזר הדיגיטלי שלך",
  "version": "גרסה",
  "formIntroText": "מלא את הטופס הבא כדי להתחיל לשוחח איתנו.",
  "formFirstName": "שם פרטי",
  "formLastName": "שם משפחה",
  "formName": "שם",
  "formEmail": "טופס דוא",
  "formWrongEmail": "הזן כתובת דוא",
  "formPhone": "טלפון",
  "formShipmentId": "מזהה משלוח",
  "formQuestion": "שאלתך",
  "formAccountNumber": "מספר חשבון (ללקוחות עסקיים)",
  "formAddress": "כתובת",
  "formPostcode": "מיקוד",
  "formCity": "עִיר",
  "formCountry": "מדינה",
  "formSubmitButton": "התחל צ'אט",
  "formEmptyFieldError": "אסור להיות ריק.",
  "formPhoneNumberValidationError": "לא מספר טלפון חוקי.",
  "formInputIsBiggerThan50": "חייב לכלול עד 50 תווים לכל היותר.",
  "formInputIsBiggerThan100": "חייב להיות לכל היותר 100 תווים.",
  "formInputIsBiggerThan2000": "חייב להיות לכל היותר 2000 תווים.",
  "widgetEventOnline": "הודעת DA: המשתמש מחובר לרשת.",
  "widgetEventHidden": "הודעת DA: יישומון מוסתר.",
  "widgetEventVisible": "הודעת DA: יישומון גלוי.",
  "widgetEventVisibleMinimized": "הודעת DA: יישומון גלוי, אך ממוזער.",
  "widgetEventMinimized": "הודעת DA: יישומון ממוזער.",
  "widgetEventMaximized": "הודעת DA: יישומון מוגדל.",
  "widgetEventSessionExpired": "הודעת DA: פג יישומון פג.",
  "widgetEventHangupHuman": "הודעת DA: משתמש שמסיים את הפעלת ההשתלטות האנושית.",
  "widgetEventUserTyping": "הודעת DA: המשתמש מקליד.",
  "fileTooLarge": "אתה מנסה לצרף קבצים גדולים מדי.",
  "tooManyDiles": "אתה מנסה לצרף יותר מדי קבצים.",
  "fileInvalidType": "אתה מנסה לצרף סוגי קבצים לא חוקיים.",
  "attachmentsDropHere": "זרוק לכאן להעלאה או",
  "attachmentsBrowse": "עיין בקבצים",
  "attachmentsExtenstionQuantity": "pdf או תמונות (עד 10 קבצים)",
  "attachmentsSize": "עד 30 מגהבייט",
  "attachmentsFailedUploading": "ההעלאה נכשלה",
  "attachmentsUploading": "מעלה ...",
  "minimizeExpandText": "צ'אט חי איתנו עכשיו!",
  "popupWidgetNotificationMessage": "קיבלת הודעה חדשה!",
  "tabWidgetNotificationMessage": "הודעה חדשה!",
  "datepickerSendButton": "לִשְׁלוֹחַ"
}
